import { AbstractJsonApiService } from './abstract-json-api.service';
import { Observable, tap } from 'rxjs';
import { IpEnvironment, Person, PICKER_LEAD_ID_STORAGE_KEY } from '@ipensii/shared/domain-shared';
import { inject } from '@angular/core';
import { EnvironmentService } from '@irian-ro/util-environment';
import { CacheService } from '../cache.service';
import { ObjectUtils } from '@ipensii/shared/util-shared';

export class UserService extends AbstractJsonApiService<Person> {
  private readonly env: EnvironmentService<IpEnvironment> = inject(EnvironmentService);
  private readonly cacheService: CacheService = inject(CacheService);

  constructor() {
    super('user');
  }

  registerUser({ email, fundId }: { email: string; fundId: string }): Observable<void> {
    const leadId = this.cacheService.getItem(PICKER_LEAD_ID_STORAGE_KEY);
    const localHost = !this.env.getEnvironment().production;
    const params = ObjectUtils.toFilteredQueryParams({ fundId, leadId, localHost });

    return this.post<void>(`register/${email}?${params}`).pipe(
      tap(() => this.cacheService.removeItem(PICKER_LEAD_ID_STORAGE_KEY))
    );
  }

  validateCurrentUser(): Observable<Person> {
    return this.post('validate', null);
  }
}
